export default "__VITE_ASSET__BhATiUfb__"